<template>
	<!-- <InfoButton @click="showOverlay" /> -->
	<VideoOverlay :scrollHint="showScrollHint()" v-if="overlayVisible" @click="hideOverlay" />
	<div class="modal modal-galerij museum-modal" data-bs-backdrop="false" id="galerijModal" tabindex="-1">
		<div class="modal-dialog modal-dialog-galerij">
			<div class="modal-content modal-content-video">
				<div class="modal-body p-0" style="max-height: 1080px; max-width: 1920px;">
					<video id="video-player" class="h-100 w-100 video-fullscreen"></video>
					<div class="gallery-btn gallery-close-btn" @click="closeModal">
						<img class="gallery-btn-img" src="~@/assets/img/exit.svg" />
					</div>
				</div>
			</div>
		</div>
	</div>
	<BackButton :text="t('back_button.overview')" link="VideoOverview"/>
	<div v-if="te('gallery')" class="container-fluid h-100 w-100">
		<h3 class="text-center museum-titel-test">{{ t(`video[${$route.params.id}].post_title`)}}</h3>
		<div class="d-flex">
			<div class="gallery-grid mx-auto museum-footer-mbs">
				<VideoOverviewItem :Overlay="index == 0 && overlayVisible" :title="video.post_title" :image="video.thumbnail" :id="index" v-for="(video, index) in tm(`video[${$route.params.id}].videos`)" :key="video" @click="openModal( video.video )" />
			</div>
		</div>
	</div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { Modal } from "bootstrap";
import VideoOverviewItem from "@/components/video/OverviewItem.vue";
import BackButton from "@/components/buttons/BackButton.vue";
import VideoOverlay from "@/components/video/VideoOverlay.vue";
import InfoButton from "@/components/buttons/InfoButton.vue";

export default {
	name: "VideoGallery",
	components: {
		VideoOverviewItem,
		BackButton,
		VideoOverlay,
		InfoButton,
	},
	setup() {
		const { t, te, tm } = useI18n();

		return { t, te, tm };
	},
	data() {
		return {
			Player: null,
			Modal: null,
			playEvent: new CustomEvent('video_callback', { detail: { type: "start" } } ),
			stopEvent: new CustomEvent('video_callback', { detail: { type: "stop" } } ),
		};
	},
	mounted() {
		let modal = document.getElementById("galerijModal");

		this.Modal = new Modal(modal);

		modal.addEventListener("hidden.bs.modal", this.onModalClosed);

		this.Player = document.getElementById("video-player");

		this.Player.addEventListener( 'ended', this.videoEnded, false);
	},
	methods: {
		closeModal(event) {
			if (this.Modal) {
				this.Modal.hide();
			}

			this.showLogo();
		},
		openModal(url) {

			this.hideLogo();

			if (this.Player) {
				this.Player.src = url;
				this.Player.play();
			}

			if (this.Modal) {
				this.Modal.show();
			}

			window.dispatchEvent(this.playEvent);
		},
		onModalClosed(e) {
			if(this.Player) {
				this.Player.pause();
			}

			window.dispatchEvent(this.stopEvent);
		},
		videoEnded(e) {
			this.closeModal();
		}
	},
};
</script>

<style scoped>
.gallery-grid {
	margin-top: 240px;
	display: grid;
	grid-template-columns: auto auto auto;
	grid-template-rows: 340px;
	column-gap: 41px;
}

.gallery-btn {
	position: absolute;
	background-color: #1F1F1F;
	width: 99px;
	height: 99px;
}

.gallery-left-btn {
	left: 0;
	top: 45%;
}

.gallery-right-btn {
	right: 0;
	top: 45%;
}

.gallery-close-btn {
	right: 0;
	top: 0;
}

.gallery-btn-img {
	position: absolute;
	height: 60px;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	margin: auto;
}

.modal-content-video {
    height: 100%;
    border-radius: 0;
    background: #000;
}
</style>